var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('obj-dice',_vm._b({attrs:{"model":_vm.model}},'obj-dice',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }